import { roles } from './usersConfig'
import IconNot1 from '../images/notifications/icon_not_1.svg'
import IconNot2 from '../images/notifications/icon_not_2.svg'
import IconNot3 from '../images/notifications/icon_not_3.svg'
import IconNot4 from '../images/notifications/icon_not_4.svg'
import IconNot5 from '../images/notifications/icon_not_5.svg'
import IconNot6 from '../images/notifications/icon_not_6.svg'
import IconNot7 from '../images/notifications/icon_not_7.svg'
import AlertIcon from '../components/atoms/icons/42/AlertIcon'
import CampaignIcon from '../components/atoms/icons/42/CampaignIcon'
import LightbulbIcon from '../components/atoms/icons/42/LightbulbIcon'
import StickyNoteIcon from '../components/atoms/icons/42/StickyNoteIcon'

const options = {
  validation: [
    { label: 'Inmediatamente', value: 'send' },
    { label: 'Programar fecha y hora', value: 'scheduled' }
  ],
  checkboxPermissions: roles.slice().reverse()
}

const icons = [
  { iconSvg: IconNot1, value: 'dispositivos' },
  { iconSvg: IconNot2, value: 'nuevo' },
  { iconSvg: IconNot3, value: 'idea' },
  { iconSvg: IconNot4, value: 'archivo' },
  { iconSvg: IconNot5, value: 'carpeta' },
  { iconSvg: IconNot6, value: 'jerarquia' },
  { iconSvg: IconNot7, value: 'general' }
]

const notificationIcons = [
  { IconSvg: LightbulbIcon, value: 'innovation', text: 'Mejoras e innovaciones' },
  { IconSvg: StickyNoteIcon, value: 'document', text: 'Normas o documentos' },
  { IconSvg: AlertIcon, value: 'alert', text: 'Alertas' },
  { IconSvg: CampaignIcon, value: 'events', text: 'Difusión de convocatorias y eventos' }
]

const sortOptions = [
  {
    value: 'created_at desc',
    label: 'Más recientes primero'
  },
  {
    value: 'created_at asc',
    label: 'Más antiguos primero'
  }
]
const headerInfo = {
  title: 'Crear notificación',
  hint: 'Configura y define el contenido de la notificación que deseas crear.'
}

const headerInfoEdit = {
  title: 'Editar notificación',
  hint: 'Configura y define el contenido de la notificación que deseas editar.'
}
const getIcon = icon => icons.find(i => i.value === icon)?.iconSvg
const getNotificationIcon = value => notificationIcons.find(i => i.value === value)

export { options, notificationIcons, sortOptions, headerInfo, headerInfoEdit, getIcon, getNotificationIcon }
